// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"76726d17","200":"da5f5271","240":"8b32c550","592":"8531c5bf"}[chunkId] + ".chunk.js";
};